import { CustomModule, fieldName, isInput, toHealthieAnswer } from "./FormField"

export interface HealthieAnswer {
  custom_module_id: string
  answer: string
}

// RHF values → Healthie `form_answers`, one per answerable module (display-only and
// unsupported modules contribute nothing). `visibleIds` (from computeVisibleIds) excludes conditional
// questions the member never saw, so a hidden question's leftover value is never submitted.
export function serializeAnswers(
  modules: CustomModule[],
  values: Record<string, unknown>,
  visibleIds: Set<string>
): HealthieAnswer[] {
  const answers: HealthieAnswer[] = []
  for (const mod of modules) {
    if (isInput(mod) && visibleIds.has(mod.id)) {
      answers.push({ custom_module_id: mod.id, answer: toHealthieAnswer(mod, values[fieldName(mod)]) })
    }
  }
  return answers
}
